import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { usePartnerDividends } from '../context/PartnerDividendsContext';

const DividendsTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerDividends();

  return (
    <thead>
      <tr className="tb-tnx-head">
        <th className="nk-tb-col text-left">
          <span>{t('Nr')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('Date')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('DividendsTotalAmount')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('%ND')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('GrossAmount')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('%Retention')}</span>
        </th>

        <th className="nk-tb-col text-right">
          <span>{t('ToPerceive')}</span>
        </th>

        {!data.isSummaryView && (
          <>
            <th className="nk-tb-col text-right">
              <span>{t('Doc')}</span>
            </th>
            <th className="nk-tb-col text-right">
              <span>{t('Letter')}</span>
            </th>
          </>
        )}
      </tr>
    </thead>
  );
};

export default DividendsTableHeader;
